// Lib
import React from 'react';
import MobileEmojiSheet from '../../../components/emoji/popup/MobileEmojiSheet';
import useReactionsPopupHooks from './useReactionsPopupHooks';
import { MobileReactionsSheetProps } from './reactionsPopupTypes';

const MobileReactionsSheet: React.FC<MobileReactionsSheetProps> = (props) => {
    const { gridSize, elementIds, closePopup, sheetProps } = props;

    const { selectedReactionIds, onSelectReaction } = useReactionsPopupHooks(elementIds);

    return (
        <MobileEmojiSheet
            sheetProps={sheetProps}
            gridSize={gridSize}
            selectedEmojiIds={selectedReactionIds}
            onSelectEmoji={onSelectReaction}
            closePopup={closePopup}
        />
    );
};

export default MobileReactionsSheet;
